import dayjs from 'dayjs';

// Pure helpers for the live-activity payload (GET /api/live-activity), shared by
// the dashboard tiles and the Connections page.

/** A booked video call is accepted but is no conversation, so the active tiles leave it out and say so. */
export function bookedCallsNote(count) {
  const n = Number(count) || 0;
  return n ? `; ${n} booked video call${n === 1 ? '' : 's'} not counted` : '';
}

export const formatUsd = (cents) =>
  (Number(cents) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

/** "oldest waiting 12 days" for an unpaid cash-out, so a stale one stands out. */
export function waitingSince(requestedAt, now = dayjs()) {
  if (!requestedAt) return null;
  const days = dayjs(now).diff(dayjs(requestedAt), 'day');
  if (!Number.isFinite(days)) return null;
  if (days < 1) return 'oldest requested today';
  return `oldest waiting ${days} ${days === 1 ? 'day' : 'days'}`;
}

export const isOpenConnection = (c) => c?.status === 'accepted' || c?.status === 'pending';

/**
 * Open connections first, then anything else that happened recently, newest
 * first within each group. `open` is complete; `recent` is the latest slice of
 * the same feed, so the two overlap and are merged by id.
 */
export function mergeLiveConnections(connections) {
  const byId = new Map();
  for (const c of [...(connections?.open || []), ...(connections?.recent || [])]) byId.set(c.id, c);
  return [...byId.values()].sort((a, b) =>
    (isOpenConnection(b) - isOpenConnection(a))
    || (dayjs(b.requestedAt).valueOf() - dayjs(a.requestedAt).valueOf())
  );
}
